/* unplugin-vue-components disabled */import { render } from "./ai-logo.vue?vue&type=template&id=2d4f991d&scoped=true"
import script from "./ai-logo.vue?vue&type=script&lang=js"
export * from "./ai-logo.vue?vue&type=script&lang=js"

import "./ai-logo.vue?vue&type=style&index=0&id=2d4f991d&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d4f991d"],['__file',"src/components/ai-chat-v2/ai-logo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2d4f991d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2d4f991d', __exports__)) {
    api.reload('2d4f991d', __exports__)
  }
  
  module.hot.accept("./ai-logo.vue?vue&type=template&id=2d4f991d&scoped=true", () => {
    api.rerender('2d4f991d', render)
  })

}


export default __exports__